import { render, staticRenderFns } from "./KarsilastirmaDataTable.vue?vue&type=template&id=01846116&scoped=true"
import script from "./KarsilastirmaDataTable.vue?vue&type=script&lang=ts"
export * from "./KarsilastirmaDataTable.vue?vue&type=script&lang=ts"
import style0 from "./KarsilastirmaDataTable.vue?vue&type=style&index=0&id=01846116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01846116",
  null
  
)

export default component.exports